import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import OSM from 'ol/source/OSM.js';
import { fromLonLat } from 'ol/proj.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Style from 'ol/style/Style.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';

// Create the base map instance
const map = new Map({
    target: 'map', // The ID of the map container div
    layers: [
        new TileLayer({
            source: new OSM() // OpenStreetMap base layer
        })
    ],
    view: new View({
        center: fromLonLat([-3.7038, 40.4168]), // Center around Spain (Madrid)
        zoom: 7 // Initial zoom level
    })
});

// Create a vector source and layer for drawing monitoring zones
const drawSource = new VectorSource();
const drawLayer = new VectorLayer({
    source: drawSource,
    style: new Style({
        fill: new Fill({
            color: 'rgba(255, 0, 0, 0.2)'
        }),
        stroke: new Stroke({
            color: '#ff0000',
            width: 2
        })
    })
});


map.addLayer(drawLayer); // Add the drawing layer to the map

// Export the map instance and drawing source/layer for use in other modules
export { map, drawSource, drawLayer };